"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var triggerEvent = function (event) {
    if (!__1.isBrowser) {
        return;
    }
    if (Event instanceof Function) {
        window.dispatchEvent(new Event(event));
    }
    else {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent(event, true, false);
        window.dispatchEvent(evt);
    }
};
exports.triggerEvent = triggerEvent;
//# sourceMappingURL=triggerEvent.js.map